const fallbackApiUrl =
  process.env.NODE_ENV === "development" ? "http://127.0.0.1:8000/api" : "/api";

export const apiUrl = (process.env.REACT_APP_API_URL || fallbackApiUrl).replace(
  /\/+$/,
  "",
);
